<template>
  <div class="design-share">
    <div class="design-share-theme">
      <div class="design-share-image">
        <a-spin :tip="$t('DesignShare.DesignShare.imageUploading')"
                size="large"
                :spinning="spinloading">
          <div class="design-share-preview">
            <a-upload-dragger v-model:file-list="fileImgList"
                              :with-credentials="withCredentials"
                              :action="toUrl('/v1/api/directAttachment/material')"
                              :multiple="true"
                              list-type="picture-card"
                              :before-upload="beforeUpload"
                              :show-upload-list="false"
                              @change="onHandleChangeImg">
              <img v-if="desginShareTheme.images.length"
                   class="desgin-share-preview-image"
                   :src="toUrl(selectdImagePreview)"
                   alt="">
              <div v-if="desginShareTheme.images.length"
                   class="mask">
                <img src="../icon/add.png"
                     alt="">
                <p>{{ $t('DesignShare.DesignShare.addDesign') }}</p>
              </div>
              <div v-else
                   class="upload">
                <div>
                  <plus-outlined />
                  <div>{{ $t('DesignShare.DesignShare.dragUpload') }}</div>
                </div>
              </div>
            </a-upload-dragger>
          </div>
        </a-spin>
        <div class="design-share-switch">
          <div class="design-share-images">
            <div v-for="(item, index) in desginShareTheme.images"
                 class="design-share-switch-images"
                 @click="onSwitchImagePreview(item.url)">
              <div v-if="desginShareTheme.editable"
                   class="image-delete"
                   @click="delelteImage(item.url)"></div>
              <img :id="'design-share-switch-image' + `${index}`"
                   :src="toUrl(item.url)"
                   @error="onHandleImageError(item.url, index)" />
            </div>
          </div>
        </div>
      </div>
      <div class="design-share-content">
        <div class="design-share-attributes">
          <div class="design-share-attribute design-share-attribute-align">
            <span class="design-share-attribute-title">{{ $t('DesignShare.DesignShare.title') }}：</span>
            <a-input v-model:value="desginShareTheme.title"
                     :maxlength="10"
                     :placeholder="$t('DesignShare.DesignShare.inputTitle')" />
          </div>
          <div class="design-share-attribute design-share-attribute-align">
            <span class="design-share-attribute-title">{{ $t('DesignShare.DesignShare.tags') }}：</span>
            <a-select v-model:value="tagsInput"
                      class="tags-select"
                      mode="multiple"
                      :placeholder="$t('DesignShare.DesignShare.selectTags')"
                      :field-names="{ label: 'name', value: 'name' }"
                      :options="tagsList"></a-select>
          </div>
          <div v-if="desginShareTheme.images.length && desginShareTheme.customable"
               class="design-share-attribute design-share-attribute-align">
            <span class="design-share-attribute-title">{{ $t('DesignShare.DesignShare.set') }}：</span>
            <div class="design-share-attribute-input">
              <a-input-number v-model:value="desginShareTheme.price"
                              :min="0"
                              :precision="2"
                              :max="9999">
                <template #addonBefore>
                  ¥
                </template>
                <template #addonAfter>
                  <a-tooltip>
                    <template #title><span>{{ $t('DesignShare.DesignShare.setPriceTooltip') }}</span></template>
                    <question-circle-outlined />
                  </a-tooltip>
                </template>
              </a-input-number>
            </div>
          </div>
          <div v-if="desginShareTheme.images.length"
               class="design-share-attribute">
            <span class="design-share-attribute-title">{{ $t('DesignShare.DesignShare.material') }}：</span>
            <div class="design-share-attribute-input">
              <a-input-number v-for="(image, index) in desginShareTheme.images"
                              v-model:value="image.price"
                              :min="0"
                              :precision="2"
                              :max="9999">
                <template #addonBefore>
                  ¥
                </template>
                <template #addonAfter>
                  {{ $t('DesignShare.DesignShare.image') + (index + 1) }}
                </template>
              </a-input-number>
            </div>
          </div>
          <div class="design-share-attribute design-share-attribute-align">
            <a-checkbox v-model:checked="desginShareTheme.free">{{ $t('DesignShare.DesignShare.free') }}</a-checkbox>
            <a-checkbox v-model:checked="desginShareTheme.customable">{{ $t('DesignShare.DesignShare.customizable')
            }}</a-checkbox>
            <a-checkbox v-if="desginShareTheme.customable"
                        v-model:checked="desginShareTheme.shareable">{{
                          $t('DesignShare.DesignShare.shareable')
                        }}</a-checkbox>
          </div>
        </div>
        <div class="desgin-sahre-buttons">
          <div class="desgin-sahre-button">
            <a-button class="design-share-save"
                      type="primary"
                      @click="onSavingShareTheme">{{
                        $t('DesignShare.DesignShare.saveShare') }}</a-button>
            <a-popconfirm :title="$t('DesignShare.DesignShare.confirmCancelShare')"
                          :ok-text="$t('DesignShare.DesignShare.confirm')"
                          :cancel-text="$t('DesignShare.DesignShare.close')"
                          @confirm="onDeletingShareTheme">
              <a-button v-if="route.query.themeId"
                        class="design-share-save"
                        type="dashed">{{
                          $t('DesignShare.DesignShare.cancelShare') }}</a-button>
            </a-popconfirm>
          </div>
        </div>
      </div>
    </div>
    <div class="design-share-customable">
      <a-tabs v-model:activeKey="categoryMenusSelectedKeys"
              type="card"
              class="design-share-tabs"
              @change="changeActiveKeys">
        <a-tab-pane v-for="(item) in categoryMenu"
                    :key="item.id"
                    :tab="item.name">
          <a-scroll-table class="scrollTable"
                          :columns="PRODUCT_COLUMNS"
                          :data-source="currentCategoriesDetail(item.id)"
                          row-key="id">
            <template #bodyCell="{ column, record }">
              <template v-if="column.dataIndex === 'customableImages'">
                <div class="preview">
                  <div v-if="(onFindCurrentSpu(record.id)?.design.length || 0) >= 2"
                       class="switch-preview"
                       @click="onSwitchPreview('left', record.id)"><img src="../icon/left.png"></div>
                  <div class="big">
                    <div v-if="onFindCurrentSpu(record.id)?.design[0]?.customized_image"
                         class="preview-image">
                      <div v-for="(design, index) in onFindCurrentSpu(record.id)!.design">
                        <ImageCustomizeEditor v-if="design.show"
                                              :id="record.id + index + ''"
                                              :key="record.id + index + ''"
                                              mode="view"
                                              :container="bigContainer"
                                              :template-basic-parameters="templateBasicParameters(findCustomImageTemplate(record.customableImages, design.spuCustomableImageId)!)"
                                              :custom-area="assignCustomizedData(design)"
                                              :customized-image="renderImageCustomUrl(design)
                                                " />
                      </div>
                    </div>
                    <img v-else
                         :src="record.customableImages[0].image"
                         alt="">
                  </div>
                  <div v-if="(onFindCurrentSpu(record.id)?.design.length || 0) >= 2"
                       class="switch-preview"
                       @click="onSwitchPreview('right', record.id)"><img src="../icon/right.png"></div>
                </div>
              </template>
              <template v-if="column.dataIndex === 'images'">
                <div class="select-color">
                  <a-radio v-model:checked="record.customableImages[0].colorChecked"
                           :disabled="!desginShareTheme.images.length || !record.editable || confirmModified(record.id)"
                           @click="onSelectedColorAll(record.customableImages[0], record.id)">{{
                            $t('DesignShare.DesignShare.selectAll') }}</a-radio>
                  <div class="select-color-images">
                    <img v-for="(images, index) in record.customableImages[0].altImages"
                         :key="index"
                         :class="findSelectedColor(images.attrs[0].object_value.value, record.id) ? 'selected-image' : ''"
                         :src="images.alt_image"
                         @click="onSelectedColor(images.attrs[0].object_value.value, record.id, record.customableImages)">
                  </div>
                </div>
              </template>
              <template v-if="column.dataIndex === 'deliver'">
                <div class="select-custom">
                  <div v-for="(customArea, index) in record.customableImages"
                       :key="customArea.id"
                       class="select-custom-area">
                    <a-checkbox :key="index"
                                v-model:checked="customArea.areaChecked"
                                :disabled="!desginShareTheme.images.length || !record.editable || confirmModified(record.id)"
                                @click="onSelecetedArea(record.id, customArea)">{{ customArea.name
                                }}</a-checkbox>
                    <div v-if="customArea.areaChecked"
                         class="select-custom-images">
                      <img v-for="(image, i) in desginShareTheme.images"
                           :key="i"
                           :class="findSelectdImage(toUrl(image.url)!, record.id, customArea.id) ? 'selected-image' : ''"
                           :src="toUrl(image.url)"
                           @click="onSelectedImage(toUrl(image.url)!, record.id, customArea)" />
                    </div>
                  </div>
                </div>
              </template>
            </template>
          </a-scroll-table>
        </a-tab-pane>
      </a-tabs>
    </div>
    <div ref="bigContainer"
         class="hidden"></div>
  </div>
</template>

<script setup lang="ts">
import { toUrl } from "@/utils"
import { ref, onMounted, reactive, computed } from "vue"
import { AScrollTable, ImageCustomizeEditor } from '@iota-cn/ui-components'
import { type CustomableImageScale, type CategoriesMenusState, type MaterialTag, type DesginShareThemeCustomizedImage, type AltImages, type DesginShareTheme, type ShareDesign, type CategoriesDetailArray, type DesignShareSpu, type CustomableImages } from '../configure'
import { templateBasicParameters, assignCustomizedData, renderImageCustomUrl, convertCustomSpuToSimpleSpu, removeDuplicates } from "../utill"
import { categoriesTypeMenu, categoriesDetail, saveShareTheme, fetchCustomSpu, fetchShareTheme, deleteShareTheme, updateShareTheme, fetchMaterialTag } from "../api"
import { productsCategoriesStore } from "../index"
import { message, type UploadChangeParam, type UploadProps, Upload, TableColumnsType } from 'ant-design-vue'
import { useRoute, useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'

const route = useRoute()
const router = useRouter()
const tagsInput = ref<string[]>([])
const tagsList = ref<MaterialTag[]>([])
const categoriesDetailArray = ref<CategoriesDetailArray[]>([])
const categoryMenusSelectedKeys = ref<number>(0)
const fileImgList = ref<any>([])
const selectdImagePreview = ref<string>('')
const categoryMenu = reactive<CategoriesMenusState["categories"]>([])
const categoryMenuText = ref<string>()
const categoriesStore = productsCategoriesStore()
const withCredentials = ref<boolean>(true)
const spinloading = ref<boolean>(false)
const bigContainer = ref()
const customSpuData = ref<any>()
const { t } = useI18n()
const desginShareTheme = ref<DesginShareTheme>({
  title: '',
  tags: '',
  price: 0,
  images: [],
  spus: [],
  free: false,
  shareable: false,
  customable: false,
  discountable: false,
  discountRate: 100,
  editable: true
})
const PRODUCT_COLUMNS = computed<TableColumnsType>(() => [
  {
    title: t('DesignShare.DesignShare.customableImages'),
    dataIndex: 'customableImages',
    width: '25%',
    ellipsis: true,
  },
  {
    title: t('DesignShare.DesignShare.images'),
    dataIndex: 'images',
    width: '30%',
    ellipsis: true,
  },
  {
    title: t('DesignShare.DesignShare.deliver'),
    dataIndex: 'deliver',
    width: '40%',
    ellipsis: true,
  }
])

onMounted(() => {
  if (route.query.customSpuId) {
    fetchCustomSpusData(Number(route.query.customSpuId))
  }
  if (route.query.themeId) {
    fetchShareThemeData(Number(route.query.themeId))
  }
  init()
})

const findCustomImageTemplate = (customableImages: CustomableImages[], CustomableImages_id: number) => {
  return customableImages.find((r: CustomableImages) => r.id === CustomableImages_id)
}

const delelteImage = (item: string) => {
  const currentImage = desginShareTheme.value.images.findIndex((r: DesginShareThemeCustomizedImage) => r.url === item)
  if (currentImage >= 0) {
    desginShareTheme.value.images.splice(currentImage, 1)
  }
  if (selectdImagePreview.value === item) {
    if (desginShareTheme.value.images.length === 0) {
      selectdImagePreview.value = ''
    } else {
      selectdImagePreview.value === desginShareTheme.value.images[0].url
    }
  }
  desginShareTheme.value.spus.forEach((r: DesignShareSpu) => {
    const findSameImage = r.design.findIndex((res: ShareDesign) => res.customized_image === item)
    if (findSameImage >= 0) {
      r.design.splice(findSameImage, 1)
      r.design[0].show = true
    }
  })
}
const validateImageSize = (file: any) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = (e: any) => {
      const image = new Image()
      image.onload = () => {
        const { width, height } = image
        if (width >= 1024 && height >= 1024) {
          resolve(true)
        } else {
          resolve(false)
        }
      }
      image.onerror = reject
      image.src = e.target.result
    }
    reader.onerror = reject
    reader.readAsDataURL(file)
  })
}

const beforeUpload: UploadProps['beforeUpload'] = async (file: any) => {
  const isPNG = file.type === 'image/png' || file.type === 'image/jpeg'
  if (!isPNG) {
    message.error(t('DesignShare.DesignShare.imageOnlyJpgOrPng'))
    return Upload.LIST_IGNORE
  }
  if (await validateImageSize(file)) {
    let splitImgName = ''
    if (file.name.includes('.png'))
      splitImgName = file.name.split('.png')[0]
    else if (file.name.includes('.jpg'))
      splitImgName = file.name.split('.jpg')[0]
    const isValidImgName = !/^[a-zA-Z0-9]+$/.test(splitImgName)
    if (isValidImgName) {
      let newName = `${splitImgName.replace(/[^\w]|[\u4e00-\u9fa5]/g, '')}`
      if (newName.length === 0)
        newName = `${new Date().getTime()}.png`
      else
        newName += '.png'
      return new File([file], newName, { type: file.type })
    } else
      return false
  } else {
    message.error(t('DesignShare.DesignShare.imageSizeAtLeast'))
    return Upload.LIST_IGNORE
  }
}

const fetchShareThemeData = async (themeId: number) => {
  await fetchShareTheme(themeId).then((res: any) => {
    desginShareTheme.value.title = res.title
    desginShareTheme.value.price = res.price
    tagsInput.value = res.tags.split(',')
    desginShareTheme.value.free = res.free
    desginShareTheme.value.discountRate = res.discountRate
    desginShareTheme.value.discountable = res.discountable
    desginShareTheme.value.editable = res.editable
    desginShareTheme.value.customable = res.customable
    desginShareTheme.value.shareable = res.shareable
    desginShareTheme.value.themeId = themeId
    const tempCustomSpuImage: DesginShareThemeCustomizedImage[] = []
    res.customSpus.forEach((customSpu: any) => {
      const design: ShareDesign[] = []
      res.shareImages.forEach((r: any) => {
        tempCustomSpuImage.push({
          url: r.image,
          price: r.ref_price
        })
        r.customImages.forEach((result: any, i: number) => {
          // 加个报错提示
          if (result.custom_spu_id === customSpu.id) {
            design.push({
              customized_image: r.image,
              pmsCustomSpuCustomizedImageId: r.id,
              spuCustomableImageId: result.spu_customable_image_id,
              show: !design.find((data: ShareDesign) => data.show),
              custom_areas: result.customableImage.custom_areas,
              customized_areas: result.customized_areas,
              width: result.customableImage.width,
              height: result.customableImage.height
            })
          }
        })
        res.customSpus.find((result: any) => result.id)
      })
      const { colors } = convertCustomSpuToSimpleSpu(customSpu)
      desginShareTheme.value.spus.push({
        id: customSpu.spu_id,
        colors,
        customSpuId: customSpu.id,
        design,
        editable: res.editable
      })
    })
    desginShareTheme.value.images = removeDuplicates(tempCustomSpuImage)
    selectdImagePreview.value = desginShareTheme.value.images[0].url
  })
}

const onSwitchImagePreview = (image: string) => {
  selectdImagePreview.value = image
}

const fetchCustomSpusData = async (id: number) => {
  const res: any = await fetchCustomSpu(id)
  customSpuData.value = res
  desginShareTheme.value.title = res.name
  const design: ShareDesign[] = []
  res.customizedImages.forEach((r: any, i: number) => {
    desginShareTheme.value.images.push({
      url: r.image,
      price: 0
    })
    design.push({
      customized_image: r.customized_image,
      pmsCustomSpuCustomizedImageId: r.id,
      spuCustomableImageId: r.customableImage.id,
      show: !i,
      custom_areas: r.customableImage.custom_areas,
      customized_areas: r.customized_areas,
      width: r.customableImage.width,
      height: r.customableImage.height
    })
  })
  selectdImagePreview.value = desginShareTheme.value.images[0].url
  const { colors } = convertCustomSpuToSimpleSpu(res)
  desginShareTheme.value.spus.push({
    id: res.spu_id,
    customSpuId: id,
    colors,
    design,
    editable: true
  })
}

const currentCategoriesDetail = (id: number | string) => {
  return categoriesDetailArray.value.find((r: CategoriesDetailArray) => r.id == id)?.spus
}

const init = async () => {
  await fetchMaterialTag().then((res) => {
    tagsList.value = res.data.items
  }).catch(() => {
    message.error(t('DesignShare.DesignShare.dataLoadError'))
  })
  await getCategoryMenus().then((id) => {
    if (id !== null && id !== undefined) {
      categoryMenusSelectedKeys.value = id as number
      getCategoryDetail(id as number)
    }
  }).catch(() => {
    message.error(t('DesignShare.DesignShare.dataLoadError'))
  })
}

const onSavingShareTheme = async () => {
  if (desginShareTheme.value.images.length === 0) {
    message.error(t('DesignShare.DesignShare.noPhotoUploaded'))
    return
  }

  desginShareTheme.value.tags = tagsInput.value.join(',')
  if (!desginShareTheme.value.tags) {
    message.error(t('DesignShare.DesignShare.atLeastOneTag'))
    return
  }

  if (desginShareTheme.value.spus.length === 0) {
    message.error(t('DesignShare.DesignShare.noDesign'))
    return
  }
  const preventEmpty = desginShareTheme.value.spus.some((r: DesignShareSpu) => {
    if (r.colors.length === 0) {
      message.error(t('DesignShare.DesignShare.selectColor'))
      return true
    }
    if (r.design.length === 0) {
      message.error(t('DesignShare.DesignShare.selectDesignArea'))
      return true
    }
    if (!r.design.some((res: ShareDesign) => res.customized_image)) {
      message.error(t('DesignShare.DesignShare.areaNoDesignImage'))
      return true
    }
    return false
  })

  if (preventEmpty)
    return

  if (route.query.themeId) {
    desginShareTheme.value.spus = desginShareTheme.value.spus.filter(spu => !spu.customSpuId)
    await updateShareTheme(Number(route.query.themeId), desginShareTheme.value).then(() => {
      message.success(t('DesignShare.DesignShare.shareUpdateSuccess'))
    })
  } else {
    await saveShareTheme(desginShareTheme.value).then(() => {
      message.success(t('DesignShare.DesignShare.shareSaveSuccess'))
      router.push(`/console/products/design_share/manage`)
    })
  }
}

const onDeletingShareTheme = async () => {
  await deleteShareTheme(Number(route.query.themeId)).then(() => {
    message.success(t('DesignShare.DesignShare.themeDeleteSuccess'))
    router.push(`/console/products/design_share/manage`)
  })
}

const onSelecetedArea = (spu_id: number, customableImage: CustomableImages) => {
  if (desginShareTheme.value.images.length === 0)
    return message.error(t('DesignShare.DesignShare.noImageUploaded'))

  let currentSpu = onFindCurrentSpu(spu_id)
  if (currentSpu) {
    const imageIndex = currentSpu.design.findIndex((r: ShareDesign) => r.spuCustomableImageId === customableImage.id)
    if (imageIndex != -1)
      currentSpu.design.splice(imageIndex, 1)
    else {
      currentSpu.design.push(calcCustomAreaParameters(desginShareTheme.value.images[0].url, customableImage))
    }
    if (currentSpu.design.length)
      currentSpu.design[0].show = true
    else {
      desginShareTheme.value.spus.splice(desginShareTheme.value.spus.findIndex((r: DesignShareSpu) => r.id === currentSpu?.id), 1)
    }
  }
  else {
    desginShareTheme.value.spus.push({
      id: spu_id,
      colors: [],
      design: [calcCustomAreaParameters(desginShareTheme.value.images[0].url, customableImage)],
      editable: true
    })
    currentSpu = onFindCurrentSpu(spu_id)
    if (currentSpu && currentSpu.design.length === 1)
      currentSpu.design[0].show = true
  }
}

const onFindCurrentSpu = (spu_id: number) => {
  return desginShareTheme.value.spus.find((r: DesignShareSpu) => r.id === spu_id)
}

const onSwitchPreview = (value: string, spu_id: number) => {
  const currentSpu = onFindCurrentSpu(spu_id)
  if (currentSpu) {
    const imageIndex = currentSpu.design.findIndex((r: ShareDesign) => r.show)
    if (imageIndex != -1) {
      currentSpu.design[imageIndex].show = false
      if (value === 'left') {
        if (imageIndex === 0) {
          currentSpu.design[currentSpu.design.length - 1].show = true
        } else {
          currentSpu.design[imageIndex - 1].show = true
        }
      } else {
        if (imageIndex === currentSpu.design.length - 1) {
          currentSpu.design[0].show = true
        } else {
          currentSpu.design[imageIndex + 1].show = true
        }
      }
    }
  }
}

const findSelectdImage = (image: string, spu_id: number, customableImages_id: number) => {
  const currentSpu = onFindCurrentSpu(spu_id)
  if (currentSpu) {
    const imageIndex = currentSpu.design.findIndex((r: ShareDesign) => r.spuCustomableImageId === customableImages_id)
    if (toUrl(currentSpu.design[imageIndex]?.customized_image) === toUrl(image))
      return true
    else return false
  }
}

const calcCustomAreaParameters = (image: string, customableImage: CustomableImages) => {
  let naturalWidth = 0
  let naturalHeight = 0
  const currentImageIndex = desginShareTheme.value.images.findIndex((r: DesginShareThemeCustomizedImage) => r.url === image)
  if (currentImageIndex >= 0) {
    const images: any = document.getElementById('design-share-switch-image' + `${currentImageIndex}`)
    if (images) {
      naturalWidth = images.naturalWidth
      naturalHeight = images.naturalHeight
    }
  }
  let scalingRatio = 0
  const widthRatio = customableImage.custom_areas.width / naturalWidth
  const heightRatio = customableImage.custom_areas.height / naturalHeight
  scalingRatio = Math.min(widthRatio, heightRatio)
  naturalWidth *= scalingRatio
  naturalHeight *= scalingRatio
  const top = customableImage.custom_areas.top + (Math.max(0, (customableImage.custom_areas.height - naturalHeight)) / 2)
  const left = customableImage.custom_areas.left + (Math.max(0, (customableImage.custom_areas.width - naturalWidth)) / 2)
  const maxScale = customableImage.scales.filter((obj: CustomableImageScale) => obj.customized_areas_scale === customableImage.scales.reduce((max: any, obj: CustomableImageScale) => obj.customized_areas_scale > max ? obj.customized_areas_scale : max, -Infinity))[0]
  const design: ShareDesign = {
    customized_image: image,
    spuCustomableImageId: customableImage.id,
    show: false,
    custom_areas: customableImage.custom_areas,
    customized_areas: {
      boundingRect: {
        top,
        left,
        width: naturalWidth,
        height: naturalHeight
      },
      discount_amount_scale: maxScale.discount_amount_scale as string,
      customable_image_scale: customableImage.custom_areas.scale,
      customized_areas_scale: maxScale.customized_areas_scale,
    },
    width: customableImage.width,
    height: customableImage.height
  }
  return design
}

const onSelectedImage = (image: string, spu_id: number, customableImage: CustomableImages) => {
  const currentSpu = onFindCurrentSpu(spu_id)
  if (currentSpu) {
    if (!currentSpu.editable || confirmModified(spu_id)) {
      return message.error(t('DesignShare.DesignShare.purchaseNoEdit'))
    }
    const imageIndex = currentSpu.design.findIndex((r: ShareDesign) => r.spuCustomableImageId === customableImage.id)
    if (imageIndex != -1) {
      currentSpu.design.splice(imageIndex, 1)
      if (currentSpu.design.length)
        currentSpu.design[0].show = true
    }
    currentSpu.design.push(calcCustomAreaParameters(image, customableImage))
    if (currentSpu.design.length === 1)
      currentSpu.design[0].show = true
    customableImage.areaChecked = true
  }
}

const onSelectedColorAll = (value: CustomableImages, spu_id: number) => {
  const currentSpu = onFindCurrentSpu(spu_id)
  const allColors = value.altImages.map((r: any) => r.attrs[0].object_value.value)
  if (currentSpu) {
    if (value.colorChecked) {
      currentSpu.colors = []
      value.colorChecked = false
    } else {
      allColors.forEach((r: string) => {
        const repeatColors = currentSpu.colors.findIndex((res: string) => res === r)
        if (repeatColors === -1)
          currentSpu.colors.push(r)
      })
      value.colorChecked = true
    }
    if (!currentSpu.design.length && !currentSpu.colors.length) {
      desginShareTheme.value.spus.splice(desginShareTheme.value.spus.findIndex((r: DesignShareSpu) => r.id === currentSpu?.id), 1)
    }
  } else {
    desginShareTheme.value.spus.push({
      id: spu_id,
      colors: allColors,
      design: [],
      editable: true
    })
  }
}

const findSelectedColor = (color: string, spu_id: number) => {
  const currentSpu = onFindCurrentSpu(spu_id)
  if (currentSpu)
    return !!currentSpu.colors.find((r: string) => r === color)
  else return false
}

const confirmModified = (spu_id: number) => {
  return !!onFindCurrentSpu(spu_id)?.customSpuId || false
}

const onSelectedColor = (color: string, spu_id: number, customableImages: CustomableImages[]) => {
  if (!desginShareTheme.value.images.length) {
    return message.error(t('DesignShare.DesignShare.uploadImageFirst'))
  }
  const currentSpu = onFindCurrentSpu(spu_id)
  if (currentSpu) {
    if (!currentSpu.editable || confirmModified(spu_id)) {
      return message.error(t('DesignShare.DesignShare.purchaseNoEdit'))
    }
    const colorIndex = currentSpu.colors.findIndex((r: string) => r === color)
    if (colorIndex != -1) {
      currentSpu.colors.splice(colorIndex, 1)
      customableImages[0].colorChecked = false
    }
    else {
      currentSpu.colors.push(color)
      const allColors = customableImages[0].altImages.map((r: any) => r.attrs[0].object_value.value)
      if (currentSpu.colors.length === allColors.length) {
        customableImages[0].colorChecked = true
      }
      customableImages.forEach((r: CustomableImages) => {
        currentSpu.design.forEach((res: ShareDesign) => {
          if (r.id === res.spuCustomableImageId)
            r.image = r.altImages.find((result: AltImages) => result.attrs[0]?.object_value.value === color)?.alt_image || ''
        })
      })
      customableImages.forEach((image: CustomableImages) => {
        const altImage = currentSpu.design
          .filter((design: ShareDesign) => image.id === design.spuCustomableImageId)
          .flatMap(() => image.altImages)
          .find((alt: AltImages) => alt.attrs[0]?.object_value.value === color)
        image.image = altImage?.alt_image || ''
      })
    }
  } else {
    desginShareTheme.value.spus.push({
      id: spu_id,
      colors: [color],
      design: [],
      editable: true
    })
    customableImages.forEach(async (r: CustomableImages, i: number) => {
      if (desginShareTheme.value.images.length >= (i + 1))
        await onSelectedImage((desginShareTheme.value.images[i].url), spu_id, r)
    })
    customableImages.forEach((r: CustomableImages) => {
      desginShareTheme.value.spus[desginShareTheme.value.spus.length - 1].design.forEach((res: ShareDesign) => {
        if (r.id === res.spuCustomableImageId)
          r.image = r.altImages.find((result: AltImages) => result.attrs[0]?.object_value.value === color)?.alt_image || ''
      })
    })
  }
}

const onHandleImageError = async (url: string, index: number) => {
  if (selectdImagePreview.value === url) {
    if (index === 0) {
      selectdImagePreview.value = ''
    } else {
      selectdImagePreview.value = desginShareTheme.value.images[index - 1].url
    }
  }
  desginShareTheme.value.images.splice(index, 1)
  message.error(t('DesignShare.DesignShare.uploadFailed'))
}

const onHandleChangeImg = async (info: UploadChangeParam) => {
  spinloading.value = true
  if (info.file.status === 'error') {
    message.error(t('DesignShare.DesignShare.imageUploadFailed'))
    fileImgList.value.splice(fileImgList.value.length - 1, 1)
    spinloading.value = false
  }
  if (info.file.status === 'done') {
    desginShareTheme.value.images.push({
      url: info.file.response.uploaded,
      price: 0
    })
    if (desginShareTheme.value.images.length === 1)
      selectdImagePreview.value = desginShareTheme.value.images[0].url
    spinloading.value = false
  }
  if (info.file.status === 'removed') {
    desginShareTheme.value.images.forEach((r, i) => {
      if (r === info.file.response?.uploaded || toUrl(r.url) === info.file.url) {
        desginShareTheme.value.images.splice(i, 1)
      }
    })
    spinloading.value = false
  }
}

const changeActiveKeys = (activeKey: number) => {
  categoryMenusSelectedKeys.value = activeKey
  if (!categoriesDetailArray.value.find((r: CategoriesDetailArray) => r.id == activeKey)) {
    getCategoryDetail(activeKey)
  }
}

const getCategoryMenus = (): Promise<string | number> => {
  return new Promise((resolve, reject) => {
    categoriesTypeMenu().then((result) => {
      const { categories } = result
      categoryMenu.length = 0
      categoryMenu.push(...categories)
      if (categoryMenu.length > 0) {
        categoryMenuText.value = categoryMenu.find((item) => item.id === categoriesStore.menusId)?.name || categoryMenu[0].name
        resolve(categoriesStore.menusId || categoryMenu[0].id)
      }
    })
  })
}

const getCategoryDetail = (id: number): void => {
  categoriesDetail(id).then((result) => {
    result.spus.forEach((r: any) => {
      const currentSpu = onFindCurrentSpu(r.id)
      if (currentSpu && r.id === currentSpu.id) {
        r.editable = currentSpu.editable
      } else {
        r.editable = true
      }
      r.customableImages.forEach((res: any) => {
        res.colorChecked = false
        res.areaChecked = false
        if (currentSpu) {
          currentSpu.design.forEach((j: any) => {
            if (j.spuCustomableImageId === res.id)
              res.areaChecked = true
          })
        }
      })
    })
    categoriesDetailArray.value.push({
      id,
      spus: result.spus
    })
  })
  categoriesStore.$patch({ menusId: id })
}
</script>
<style scoped lang="less">
.design-share {
  width: 100%;
  height: 100%;
  padding: 20px;
  overflow: auto;
  display: flex;

  :deep(.ant-table) {
    border: 1px solid #F1F1F1;
  }

  .design-share-theme {
    height: 100%;
    width: 25%;
    padding: 20px;
    box-shadow: 0px 0px 14px 0px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-flow: column;
    justify-content: space-between;

    .design-share-image {
      width: 100%;
      height: 55%;
      display: flex;
      flex-direction: column;

      .design-share-preview {
        height: 300px;
        display: flex;
        background-color: #f6f6f6;
        justify-content: center;
        align-items: center;
        position: relative;

        :deep(.ant-upload) {
          min-width: 300px;
          max-width: 300px;
        }

        .desgin-share-preview-image {
          cursor: pointer;
          height: auto;
          max-height: 300px;
          width: auto;
          max-width: 300px;
        }

        .upload {
          display: flex;
          justify-content: center;
          align-items: center;
          min-height: 300px;
          max-height: 300px;
          width: 300px;
        }

        :deep(.ant-upload.ant-upload-drag .ant-upload) {
          padding: 0;
        }

        .mask {
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          opacity: 0;
          background-color: #00000092;

          img {
            width: 50px;
            width: 50px;
            margin-bottom: 10px;
          }
        }

        .mask:hover {
          opacity: 1;
          display: flex;
          flex-flow: column;
          justify-content: center;
          align-items: center;
          color: white;
        }
      }

      .design-share-switch {
        width: 100%;
        flex: 1;
        display: flex;

        .design-share-switch-tab {
          flex: 1;
          border: 1px solid #F1F1F1;
        }

        .design-share-images {
          flex: 1;
          display: flex;
          overflow: auto;

          .design-share-switch-images {
            margin-top: 10px;
            margin-right: 10px;
            height: 55px;
            min-width: 55px;
            background-color: #f6f6f6;
            display: flex;
            justify-content: center;
            align-items: center;
            position: relative;

            .image-delete {
              cursor: pointer;
              position: absolute;
              background: url('../icon/delete.png') no-repeat center center/cover;
              width: 20px;
              height: 20px;
              border-radius: 10px;
              background-color: #1111116a;
              top: -10px;
              right: -10px;
            }

            img {
              cursor: pointer;
              height: auto;
              max-height: 55px;
              width: auto;
              max-width: 55px;
            }
          }
        }
      }
    }

    .design-share-content {
      flex: 1;
      display: flex;
      flex-flow: column;
      justify-content: space-between;
      align-items: center;
      overflow: auto;
      padding-top: 20px;

      .design-share-attributes {
        width: 100%;
        flex: 1;
        overflow: auto;

        .design-share-attribute-tags {
          flex-wrap: wrap;
        }

        .design-share-attribute-align {
          align-items: center;
        }

        .design-share-attribute {
          padding-bottom: 20px;
          width: 100%;
          display: flex;

          .design-share-attribute-input {
            flex: 1;
          }

          :deep(.ant-input-number-group-wrapper) {
            width: 100%;
          }

          :deep(.ant-input-number-group-addon) {
            width: 50px;
          }

          .tags-enter {
            cursor: pointer;
          }

          .tags-select {
            width: 100%;
          }

          .tags-list {
            background: #F1F1F1;
            padding: 5px;
            margin-right: 5px;
            margin-top: 5px;

            .tags-list-delete {
              color: #999999;
            }
          }

          .design-share-attribute-title {
            min-width: 50px;
          }

          :deep(.ant-input) {
            flex: 1;
          }

          .unit {
            margin-left: 10px;
            color: #999999;
          }
        }
      }

      .desgin-sahre-buttons {
        width: 100%;
        display: flex;
        justify-content: center;

        .desgin-sahre-button {
          width: 100%;
          display: flex;
          justify-content: space-around;

          .design-share-save {
            width: 100%;
          }
        }
      }
    }
  }

  .design-share-customable {
    padding: 20px 20px;
    flex: 1;
    max-width: 60vw;

    :deep(.ant-tabs-nav) {
      position: static;
    }

    :deep(.ant-tabs-tab) {
      width: 100px;
      height: 40px;
      border: 1px solid #F1F1F1;
      display: flex;
      justify-content: center;
      background: #FFFFFF;
      margin-right: 20px;
    }

    :deep(.ant-tabs-tab-active) {
      background-color: #000000;

      .ant-tabs-tab-btn {
        color: white;
      }
    }

    :deep(.ant-tabs) {
      height: 100%;
    }

    :deep(.ant-tabs-content) {
      height: 100%;
    }

    .scrollTable {
      flex: 1;
      height: 100%;

      .select-custom {
        height: 180px;
        overflow: auto;

        .select-custom-area {
          display: flex;
          flex-flow: column;
          gap: 5px;
          margin-bottom: 10px;

          .select-custom-images {
            display: flex;
            gap: 15px;

            img {
              cursor: pointer;
              width: auto;
              max-width: 30px;
              height: auto;
              max-height: 30px;
            }
          }
        }
      }

      .selected-image {
        border: 1px solid;
      }

      .select-color {
        height: 180px;

        .select-color-images {
          margin-top: 20px;
          width: 100%;
          display: flex;
          flex-wrap: wrap;
          gap: 15px;

          img {
            cursor: pointer;
            width: auto;
            max-width: 40px;
            max-height: 40px;
            height: auto;
          }
        }
      }

      .preview {
        display: flex;
        justify-content: space-around;
        align-items: center;

        .switch-preview {
          cursor: pointer;
          width: 30px;
          height: 30px;
          background: #FFFFFF;
          box-shadow: 0px 6px 12px 0px rgba(0, 0, 0, 0.1);
          border-radius: 15px;
          display: flex;
          justify-content: center;
          align-items: center;
          display: flex;
          align-items: center;
          justify-content: center;

          img {
            width: 5px;
            height: 10px;
          }
        }

        .big {
          width: 150px;
          height: 150px;

          .preview-image {
            width: 150px;
            height: 150px;
          }

          @-moz-document url-prefix() {
            :deep(.fabric-div) {
              width: 180px !important;
              height: 180px !important;
            }

            :deep(.canvas-container) {
              width: 180px !important;
              height: 180px !important;
            }

            :deep(.lower-canvas) {
              width: 180px !important;
              height: 180px !important;
            }

            :deep(.upper-canvas) {
              width: 180px !important;
              height: 180px !important;
            }
          }

          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }

  .hidden {
    width: 150px;
    height: 150px;
    position: absolute;
    visibility: hidden;
    display: block;
  }
}
</style>
